/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TermProviderAccreditationAliases {
  FETCH_TERM_PROVIDER_ACCREDITATION = 'fetch-term-provider-accreditation',
  PANEL_TERM_PROVIDER = 'panel-term-provider',
  PANEL_TERM_PROVIDER_ACCREDITATION = 'panel-term-provider-accreditation',
  TERM_SERVICE_TERM_OF_USE = 'term-service-term-of-use',
}
export { TermProviderAccreditationAliases };
